import { Link } from "react-router-dom";

/*
const i =
  type === "approved"
    ? "fa-check-circle-o"
    : type === "pending"
    ? "fa-hourglass-o"
    : "fa-times-circle-o";
  */

const TdDayHdg = ({ d }) => {
	return (
		<td className="center" style={{ width: "3.5%", fontSize: "0.9rem" }}>
			{d}
		</td>
	);
};

const TdDayVal = ({ status }) => {
	const i =
		status === 1 ? "fa-check" : status === 2 ? "fa-hourglass-o" : "fa-times";

	return (
		<td className="center" style={{ verticalAlign: "middle" }}>
			<span
				className={
					status === 1
						? "success"
						: status === 2
						? "working"
						: status === 0
						? "error"
						: "invisible"
				}
			>
				<div style={{ fontSize: "1rem", paddingTop: "4px" }}>
					<i className={`fa ${i}`}></i>
				</div>
			</span>
		</td>
	);
};

const TdConfirmedVal = ({ status, inProcess, text }) => {
	return (
		<td>
			{text ? (
				<span className="success">confirmed</span>
			) : inProcess ? (
				<span className="notice">in process</span>
			) : status === 1 ? (
				<span className="notice">approved</span>
			) : status === 2 ? (
				<span className="working">pending</span>
			) : (
				<span className="error">unavailable</span>
			)}
		</td>
	);
};

const HomeTable = ({ type, text, data, registrationId }) => {
	let hasPending = false;

	return (
		<table
			className="approved assigned"
			style={{ marginTop: "0", marginBottom: "25px" }}
		>
			<thead>
				<tr>
					<th colSpan="13" className="hdg">
						<p>{text}</p>
					</th>
				</tr>
			</thead>
			<thead>
				<tr>
					<td
						className="center"
						rowSpan="2"
						style={{ paddingTop: "0", paddingBottom: "0" }}
					>
						Request Details
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{ paddingTop: "0", paddingBottom: "0" }}
					>
						Hotel
					</td>
					<td className="center" colSpan="9">
						March 28 - April 5
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{ width: "10%", paddingTop: "0", paddingBottom: "0" }}
					>
						Status
					</td>
					<td
						className="spot"
						rowSpan="2"
						style={{ width: "10%", paddingTop: "0", paddingBottom: "0" }}
					>
						Last
						<br />
						Updated
					</td>
				</tr>
				<tr>
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
					<TdDayHdg d="T" />
					<TdDayHdg d="W" />
					<TdDayHdg d="T" />
					<TdDayHdg d="F" />
					<TdDayHdg d="S" />
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
				</tr>
			</thead>
			{data.length > 0 ? (
				<tbody>
					{data.map((item) => {
						if (item.status === 2) {
							hasPending = true;
						}

						return (
							<tr key={`${item.id}`}>
								<td className="left">
									<Link to={`/admin/hotel/edit/${item.encryptedId}`}>
										{item.details}
									</Link>
								</td>
								<td className="left">{item.hotel}</td>
								<TdDayVal status={item.sun1} />
								<TdDayVal status={item.mon1} />
								<TdDayVal status={item.tue1} />
								<TdDayVal status={item.wed1} />
								<TdDayVal status={item.thu1} />
								<TdDayVal status={item.fri1} />
								<TdDayVal status={item.sat1} />
								<TdDayVal status={item.sun2} />
								<TdDayVal status={item.mon2} />
								<TdConfirmedVal
									status={item.status}
									inProcess={item.inProcess}
									text={item.confirmation}
								/>
								<td>{item.updated}</td>
							</tr>
						);
					})}
					<tr>
						<td
							className="center"
							colSpan="13"
							style={{
								paddingTop: "12.5px",
								paddingBottom: "12.5px",
							}}
						>
							{hasPending ? (
								<span>
									<Link to={`/admin/hotel/bulk/${registrationId}`}>
										Bulk Approve Pending Requests
									</Link>
								</span>
							) : (
								<span className="working">
									There are currently no pending requests available for bulk
									approving.
								</span>
							)}
						</td>
					</tr>
				</tbody>
			) : (
				<tbody>
					<tr>
						<td colSpan="13">
							<span className="working">-- no requests found --</span>
						</td>
					</tr>
				</tbody>
			)}
		</table>
	);
};

export default HomeTable;
